import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useScreen } from '../../../../hooks'
import { preventDefault, stopPropagation } from '../../../../utils/events'
import { FormikWysiwygField } from '../../../Formik'
import { QA_NAME_INPUT_CONTEXT } from '../../../Input'
import { PostMessageTemplateSelectFormikField } from '../../../Post'

import { NEWSBOARD_MESSAGE_FIELD_WYSIWYG_MIN_HEIGHT } from './NewsboardMessageFieldEditor.constants'

import * as styles from './NewsboardMessageFieldEditor.module.css'

function NewsboardMessageFieldEditor({
  autoFocus,
  className = styles.NewsboardMessageFieldEditor,
  isStaffUserAcc,
  name,
  skipFieldWrapper,
  templateFieldName,
  onInitEditor,
}) {
  const { t } = useTranslation()

  const { errors } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  function handleClickField(e) {
    stopPropagation(e)
    preventDefault(e)
  }

  return (
    <div className={className} onClick={handleClickField}>
      {isStaffUserAcc && templateFieldName ? (
        <PostMessageTemplateSelectFormikField
          Field={skipFieldWrapper ? Fragment : undefined}
          controlProps={{
            borderless: !isMobileScreenSize,
            contentProps: {
              inputProps: {
                placeholder: t('Newsboard.TextMessageTemplatePlaceholderKey'),
              },
            },
          }}
          fieldComponentProps={
            skipFieldWrapper
              ? undefined
              : {
                  label: t('Newsboard.MessageLabelKey'),
                  required: true,
                  shouldAdaptToMobileScreen: true,
                }
          }
          name={templateFieldName}
        />
      ) : null}
      <FormikWysiwygField
        enableTables
        Field={skipFieldWrapper ? Fragment : undefined}
        autoFocus={autoFocus}
        buttonClassName={styles.selectButton}
        error={errors[name]}
        fieldComponentProps={
          skipFieldWrapper
            ? undefined
            : {
                label: isStaffUserAcc
                  ? true
                  : `${t('Newsboard.MessageLabelKey')}:`,
                required: !isStaffUserAcc,
                shouldAdaptToMobileScreen: true,
              }
        }
        minHeight={NEWSBOARD_MESSAGE_FIELD_WYSIWYG_MIN_HEIGHT}
        name={name}
        placeholder={t('Newsboard.MessageFieldPlaceholderKey')}
        qaBtnProps={{ context: QA_NAME_INPUT_CONTEXT, value: name }}
        wrapperClassName={styles.wrapperClassName}
        onInit={onInitEditor}
      />
    </div>
  )
}

export default NewsboardMessageFieldEditor
